import { render, staticRenderFns } from "./user-view.vue?vue&type=template&id=58e471c8&scoped=true"
import script from "./user-view.vue?vue&type=script&lang=js"
export * from "./user-view.vue?vue&type=script&lang=js"
import style0 from "./user-view.vue?vue&type=style&index=0&id=58e471c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e471c8",
  null
  
)

export default component.exports